import React from "react"
import { Checkbox } from "antd"
import PropTypes from "prop-types"

export const ExperienceOption = ({ option, experienceOptions, form }) => {
  const handleChange = (e) => {
    const prev = form.getFieldValue("experience") || []
    if (e.target.checked) {
      form.setFieldsValue({ experience: [...prev, option.value] })
    } else {
      form.setFieldsValue({ experience: prev.filter((v) => v !== option.value) })
    }
  }

  return (
    <div key={option.value} style={{ display: "flex", alignItems: "center", padding: "8px 16px" }}>
      <Checkbox checked={experienceOptions?.includes(option.value)} onChange={handleChange}>
        {option.label}
      </Checkbox>
    </div>
  )
}

ExperienceOption.propTypes = {
  option: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired
  }).isRequired,
  experienceOptions: PropTypes.array,
  form: PropTypes.object.isRequired
}
